import React from 'react';
import styles from './regulatoryDisclaimer.module.css';
import IMAGES from '../../../assets/images/images';
import { Loader } from '../../../components/loader/Loader';

const RegulatoryDisclaimer = ({onAccept,loader, setShowConsentPopup }) => {
  return (
    <div className={styles.alertmessage}> 
      <div className={styles.alertcontent}>
      <div className={styles.header}>
      <div className={styles.errormsghead}><img className={styles.vectorimg} src={IMAGES.Vector}/>{"Disclaimer"}</div>
       <div className={styles.close}><img className={styles.closeimg} onClick={()=>{setShowConsentPopup(false)}}  src={IMAGES.close}/></div>
     </div>
        <div className={styles.errormsg}>The advertised data is Vodafone interpretation of regulatory guidelines from different countries, and associated reference is provided alongside. Voice calls handling into Vodafone platform are based on this interpretation. In case customer have different interpretation for specific section, they should contact Vodafone. This data cannot be used for any other purpose. Copy/download/forwarding of data is not allowed.</div>
        <div className={styles.buttonok}>
        {loader ? <Loader/>: <button className={styles.buttonscan} onClick={onAccept}>Yes, I Understand</button>}
        </div>
      </div>
    </div>
  );
};

export default RegulatoryDisclaimer;